import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import SocialButtons from './SocialButtons';
import { BUSINESS } from '../lib/business';
import { useSiteContent } from '../hooks/useSiteContent';

export default function Footer() {
  const { content: contacts } = useSiteContent('site.contacts');

  return (
    <footer className="bg-secondary/60 pt-12 pb-6 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">
              <span className="text-primary font-semibold">Apicoltura</span><span className="text-foreground font-semibold">DePiccoli</span>
            </h3>
            <p className="text-sm text-muted-foreground mb-4">
              Seguici per vedere le api al lavoro e sapere quando arriva il nuovo raccolto.
            </p>
            <SocialButtons className="max-w-xs" />
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">
              Link Utili
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Tutti i prodotti
                </Link>
              </li>
              <li>
                <Link to="/il-miele" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Il nostro miele
                </Link>
              </li>
              <li>
                <Link to="/ricette" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Ricette
                </Link>
              </li>
              <li>
                <Link to="/novita" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Eventi e novità
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Contatti
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Assistenza clienti */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">
              Assistenza clienti
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/orders" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Traccia il tuo ordine
                </Link>
              </li>
              <li>
                <Link to="/spedizioni" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Spedizioni
                </Link>
              </li>
              <li>
                <Link to="/resi" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Recesso e resi
                </Link>
              </li>
              <li>
                <Link to="/condizioni-di-vendita" className="text-muted-foreground hover:text-primary transition-colors link-hover">
                  Condizioni di vendita
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-4">
              Contattaci
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-primary mr-2" />
                <a href={`mailto:${contacts.email}`} className="text-muted-foreground hover:text-primary transition-colors break-all">
                  {contacts.email}
                </a>
              </li>
              {contacts.phone && (
                <li className="flex items-center">
                  <Phone className="h-5 w-5 text-primary mr-2" />
                  <a href={`tel:${contacts.phone.replace(/\s+/g, '')}`} className="text-muted-foreground hover:text-primary transition-colors">
                    {contacts.phone}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm text-center md:text-left">
            © {new Date().getFullYear()} {BUSINESS.legalName} · P.IVA {BUSINESS.vatNumber}. Tutti i diritti riservati.
          </p>
          <div className="flex space-x-6">
            <Link
              to="/privacy"
              className="text-muted-foreground text-sm hover:text-primary link-hover"
            >
              Privacy Policy
            </Link>
            <Link
              to="/condizioni-di-vendita"
              className="text-muted-foreground text-sm hover:text-primary link-hover"
            >
              Condizioni di vendita
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
